module.exports = __webpack_public_path__ + "img/weight-icon.5a21a633.svg";